import {mapQuizSessionDbToType, QuizSession, QuizSessionState} from '@cp/model';
import {limit as limitFirestore, onSnapshot, orderBy, query, where} from 'firebase/firestore';
import mapFirestoreQuerySnapshotToData from '../../helper/firebase/mapFirestoreQuerySnapshotToData';
import getQuizSessionCollection from './getQuizSessionCollection';

const DEFAULT_LIMIT = 10;

export default function subscribeQuizSessionCollectionActive(
  uid: string,
  onData: (sessions: QuizSession[]) => void,
  onError?: (err: Error) => void,
  limit: number = DEFAULT_LIMIT,
): () => void {
  const col = getQuizSessionCollection(uid);
  const q = query(col, where('endedAt', '==', null), orderBy('startedAt', 'desc'), limitFirestore(limit));
  return onSnapshot(
    q,
    (snapshot) => {
      const sessions = mapFirestoreQuerySnapshotToData(snapshot, (doc) => {
        const session = mapQuizSessionDbToType(doc);
        if (session.state !== QuizSessionState.ACTIVE) throw new Error('Session is not active');
        return session;
      });
      onData(sessions);
    },
    (err) => onError?.(err),
  );
}
